































import { Vue, Component, Prop } from 'vue-property-decorator'
import { TableList } from '@/shims-global'
import MainTitle from '../_components/MainTitle.vue'
import ItemTable from '../_components/ItemTable.vue'
import TagTitle from '../_components/TagTitle.vue'
@Component({
  components: {
    MainTitle,
    ItemTable,
    TagTitle
  }
})
export default class extends Vue {
  @Prop({}) private data!: any

  private list: Array < object > = [];
  private childList: Array < object > = [];

  private tableHeader: any = ['班级', '最高分', '最低分', '标准差', '总分']
  private tableDetail: any = {}

  created() {
    this.list = this.data.array.slice(0, 6)
    this.childList = this.data.array.slice(6, 9)
    this.list.map(v => {
      v.tableDetail = {
        leftTitle: v.ChangeInChildEnergyZoneTypeIntro,
        children: []
      }
      v.mathVoList.map(q => {
        v.tableDetail.children.push({
          parName: q.ClassroomTypeIntro,
          name1: q.maxScore,
          name2: q.minScore,
          name3: q.standardDeviation,
          name4: q.mean
        })
      })
    })
    this.childList.map(v => {
      v.tableDetail = {
        leftTitle: v.ChangeInChildEnergyZoneTypeIntro,
        children: []
      }
      v.mathVoList.map(q => {
        v.tableDetail.children.push({
          parName: q.ClassroomTypeIntro,
          name1: q.maxScore,
          name2: q.minScore,
          name3: q.standardDeviation,
          name4: q.mean
        })
      })
    })
  }
}
